import { t } from 'i18next';

export function formatNumber(
  value: number | string,
  isDot: boolean = false,
  decimals: number = 1,
) {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (isNaN(num)) return '';

  const hasDecimal = !Number.isInteger(num);

  const formatted = new Intl.NumberFormat('en-US', {
    // minimumFractionDigits: hasDecimal ? decimals : 0,
    maximumFractionDigits: hasDecimal ? decimals : 0,
  }).format(num);

  return isDot ? formatted : formatted.replace(/,/g, ' ');
}

/** API null/undefined qaytarganda chiziqcha, aks holda formatlangan son (+ birlik). */
export function formatNumberOrDash(
  value?: number | null,
  suffix: string = '',
) {
  if (value === null || value === undefined) return '-';
  return formatNumber(value) + suffix;
}

/** `getUnitLabel` qaytaradigan birlikka mos miqyoslangan son.
 *  Masalan 1 073 257 344 -> 1.07 ("mlrd. so'm" birligi bilan juft ishlatiladi). */
export function getScaledValue(value: number): number {
  const divisors: Record<ReturnType<typeof getScaleUnit>, number> = {
    unit: 1,
    thousand: 1_000,
    million: 1_000_000,
    billion: 1_000_000_000,
    trillion: 1_000_000_000_000,
  };
  return value / divisors[getScaleUnit(value)];
}

export function formatNumberWithAutoScale(
  value: number,
  isDot: boolean = false,
  decimals: number = 1,
): string {
  if (value === null || value === undefined || value === 0) return '0';

  const absValue = Math.abs(value);
  const digitCount = Math.floor(Math.log10(absValue)) + 1;

  let divisor = 1;

  if (digitCount >= 13) {
    divisor = 1000000000000;
  } else if (digitCount >= 10) {
    divisor = 1000000000;
  } else if (digitCount >= 7) {
    divisor = 1000000;
  } else if (digitCount >= 4) {
    divisor = 1000;
  }

  return formatNumber(value / divisor, isDot, decimals);
}

export function getScaleUnit(
  value: number,
): 'thousand' | 'million' | 'billion' | 'trillion' | 'unit' {
  if (value === null || value === undefined || value === 0) return 'unit';

  const absValue = Math.abs(value);
  const digitCount = Math.floor(Math.log10(absValue)) + 1;

  if (digitCount >= 13) {
    return 'trillion';
  } else if (digitCount >= 10) {
    return 'billion';
  } else if (digitCount >= 7) {
    return 'million';
  } else if (digitCount >= 4) {
    return 'thousand';
  }

  return 'unit';
}

export const getUnitLabel = (
  value: number,
  type: 'ton' | 'currency' | 'ga' = 'ton',
): string => {
  const unit = getScaleUnit(value);

  switch (unit) {
    case 'thousand':
      return type === 'ton'
        ? t('ton_ming')
        : type === 'ga'
          ? t('ming_ga')
          : t('ming_currency');

    case 'million':
      return type === 'ton'
        ? t('mln_ton')
        : type === 'ga'
          ? t('mln_ga')
          : t('mln_currency');

    case 'billion':
      return type === 'ton'
        ? t('ton_mlrd')
        : type === 'ga'
          ? t('mlrd_ga')
          : t('mlrd_currency');

    case 'trillion':
      return type === 'ton'
        ? t('trln_ton')
        : type === 'ga'
          ? t('trln_ga')
          : t('trn_currency');

    default:
      return type === 'ton'
        ? t('ton')
        : type === 'ga'
          ? t('ga')
          : t('currency');
  }
};
